import React from 'react';
import { SendJsonMessage } from 'react-use-websocket/dist/lib/types';
import { SessionWebhookResponse } from './types';

interface WebsocketApiConnectionContextProps {
  lastJsonMessage: SessionWebhookResponse | null;
  sendJsonMessage: SendJsonMessage;
}

export const WebsocketApiConnectionContext = React.createContext<WebsocketApiConnectionContextProps | null>(null);

export default function useWebsocketApiConnectionContext() {
  const context = React.useContext(WebsocketApiConnectionContext);
  if (context === null) {
    throw new Error('useWebsocketApiConnectionContext must be used within a WebsocketApiConnectionContextProvider');
  }
  return context;
}
